import ApplicationLogo from '@/Components/ApplicationLogo.jsx';
import YaKHeaderHeadings from '@/Components/Layouts/Themed/YaKHeaderHeadings.jsx';
import { Link as InertiaLink } from '@inertiajs/react';
import { AppBar, Box, Container, styled, Toolbar } from '@mui/material';
import React, { memo, useMemo, useState } from 'react';

const HeaderLogo = styled(ApplicationLogo)({
    objectFit: 'contain',
    width: '100%',
    height: '100%',
});

const getNavItems = (user, brand) => {
    let result = [];
    /*if (brand === 'ya-k') {
        result.push({
            name: "Retour à l'accueil",
            variant: 'contained',
            //color: 'text',
            color: 'primary',
            href: 'https://www.yak-construire.com/',
            external_link: true,
            sx: { fontWeight: 'bold' },
        });
    }
    if (user) {
        result.push({
            name: 'Tableau de bord',
            color: 'text',
            href: route('dashboard.index'),
        });
        result.push({
            name: 'Votre compte',
            color: 'text',
            href: route('profile.edit'),
        });
        result.push({
            name: 'Déconnexion',
            variant: 'contained',
            method: 'POST',
            href: route('logout'),
            sx: { fontWeight: 'bold' },
        });
    }*/
    return result;
};

const Header = ({ brand, user }) => {
    const [anchorElNav, setAnchorElNav] = useState(null);
    const nav_items = useMemo(() => getNavItems(user, brand), [user, brand]);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const styles = {
        app_bar: {
            border: '1px solid rgba(0, 0, 0, 0.1)',
        },
        container: (theme) => ({
            maxWidth: theme.breakpoints.xl,
        }),
        toolbar: {
            justifyContent: 'space-between',
        },
        desktop_right_block: {
            //display: { xs: 'none', md: 'flex' },
            display: 'flex',
            flexFlow: 'column nowrap',
        },
        desktop_nav: {
            display: 'flex',
            gap: 2,
        },
        desktop_nav_item: {
            my: 2,
        },
        desktop_nav_button: {
            display: 'block',
            textDecoration: 'none',
        },
        logo: {
            display: 'inline-block',
            flexGrow: { xs: 1, md: 0 },
            width: '132px',
            //height: '35px',
            height: '87px',
        },
        mobile_menu_icon: {},
    };

    switch (brand) {
        case 'ya-k':
            styles.app_bar = {
                alignItems: 'stretch',
            };
            styles.container = (theme) => ({
                [theme.breakpoints.up('lg')]: {
                    width: '75vw',
                    maxWidth: '1920px !important',
                    padding: '0 64px !important',
                    gap: 6,
                },
            });
            styles.toolbar = (theme) => ({
                ...styles.toolbar,
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: { xs: 0, md: 3, lg: 6 },
                minHeight: '175px !important',
            });
            styles.desktop_right_block = (theme) => ({
                ...styles.desktop_right_block,
                position: 'relative',
                justifyContent: 'flex-end',
                flexWrap: 'wrap',
                flex: 1,
                [theme.breakpoints.down('md')]: {
                    flex: '1 0 100%',
                    order: -1,
                },
            });
            styles.desktop_nav = {
                ...styles.desktop_nav,
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                flex: 0,
                gap: 0,
            };
            styles.desktop_nav_item = (theme) => ({
                padding: '0 22px',
                [theme.breakpoints.up('xl')]: {
                    padding: '0 34px',
                },
                [`@media (min-width: 1620px)`]: {
                    padding: '0 62px',
                },
            });
            styles.logo = {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '48px auto 0',
                width: '190px',
                height: '131px',
                flex: '0 0 auto',
            };
            styles.mobile_menu_icon = {
                fontSize: '2rem',
            };
            break;
        case 'couleur-villas':
            break;
    }

    return (
        <>
            <AppBar position={brand === 'ya-k' ? 'static' : 'fixed'} color="white" elevation={0} sx={styles.app_bar}>
                <Container sx={styles.container}>
                    <Toolbar disableGutters sx={styles.toolbar}>
                        <InertiaLink href={route('configurator.index')} style={styles.logo}>
                            <HeaderLogo />
                        </InertiaLink>
                        {/*<Box
                            sx={{
                                display: { xs: 'flex', md: 'none' },
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                            }}
                        >
                            <IconButton
                                size="large"
                                aria-label="Menu"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon sx={styles.mobile_menu_icon} />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{ display: { xs: 'block', md: 'none' } }}
                            >
                                {nav_items.map(({ name, href }) => (
                                    <MenuItem key={'mobile-' + name} onClick={handleCloseNavMenu}>
                                        <Typography sx={{ textAlign: 'center' }}>{name}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>*/}
                        <Box sx={styles.desktop_right_block}>
                            {brand === 'ya-k' && <YaKHeaderHeadings />}
                            {/*<Box sx={styles.desktop_nav}>
                                {nav_items.map(
                                    ({ name, variant, color, method, href, external_link = false, sx = {} }) => (
                                        <InertiaButton
                                            key={name}
                                            method={method}
                                            href={href}
                                            style={styles.desktop_nav_button}
                                            variant={variant}
                                            color={color}
                                            size="large"
                                            external={external_link}
                                            sx={styles.desktop_nav_item}
                                        >
                                            <Typography sx={{ textAlign: 'center', ...sx }}>{name}</Typography>
                                        </InertiaButton>
                                    ),
                                )}
                            </Box>*/}
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    );
};
export default memo(Header);
